<template>
  <div id="home" class="about">
    <Navigator id="nav"/>
    <h1>This is an about page with Keycloak authenticated</h1>
    <h1>This is a secret about page. You should only be able to see this if you are authenticated.</h1>
    <h3>This is what my token looks like:</h3>
    <code>{{ $keycloak.tokenParsed }}</code>
    <code>{{ $keycloak.logoutFn }}</code>
    <h3>{{message}}</h3>
  </div>  
</template>

<script>
import axios from 'axios'
import Navigator from '@/components/Navigator.vue'

export default {
  name: 'About',
  data () {
    return {
      message: '',
    }
  },
  methods: {
    loadUserName: function() {
      //Login as registered user
      console.log(this.$keycloak.logoutFn)
      var urlRequest = '/rest/currentuser'
      axios({url: urlRequest, method: 'GET' , headers: {"Authorization" : `Bearer ${this.$keycloak.token}` }} )
      .then(resp => {
          this.message = resp.data;
          //console.log(resp)
          console.log(this.message)
      })
      .catch(err =>{
        console.log(err)
      })
    },
  },
  beforeMount(){
    this.loadUserName()
  },
  components: {
    Navigator
  }
}
</script>
<style scoped>
#home {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
